import { render } from "./StaticItem.vue?vue&type=template&id=b2c36e00"
import script from "./StaticItem.vue?vue&type=script&lang=js"
export * from "./StaticItem.vue?vue&type=script&lang=js"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__